import { SketchPicker } from 'solid-color';
import { Button, Form, Row, Col } from "solid-bootstrap";
import { Show, createSignal, createEffect } from 'solid-js';

export function ColorField(props) {
    const [color, setColor] = createSignal(parseColor(props.valueFunc(props.themeSignal())));
    const [isShowPicker, setShowPicker] = createSignal(false);

    createEffect(() => {
        setColor(parseColor(props.valueFunc(props.themeSignal())));
    });

    function parseColor(color) {
        if (color === undefined) {
            return { r: 0, g: 0, b: 0, a: 1.0 };
        }
        var alpha = hexToNum(color.substring(7, 9)) / 255;
        if (isNaN(alpha)) {
            alpha = 1.0;
        }
        // Example color: #ff0000ff
        return {
            r: hexToNum(color.substring(1, 3)),
            g: hexToNum(color.substring(3, 5)),
            b: hexToNum(color.substring(5, 7)),
            a: alpha,
        };
    }

    function hexToNum(hex) {
        return parseInt(hex, 16);
    }

    function numToHex(numMax255) {
        const hex = Math.round(numMax255).toString(16);
        return hex.length === 1 ? '0' + hex : hex;
    }

    function renderColor(color) {
        let a = color.a * 255;
        let r = color.r;
        let g = color.g;
        let b = color.b;
        if (a === undefined) {
            a = 255;
        }
        return `#${numToHex(r)}${numToHex(g)}${numToHex(b)}${numToHex(a)}`;
    }

    function renderRGBOnly(color) {
        const r = color.r;
        const g = color.g;
        const b = color.b;
        return `#${numToHex(r)}${numToHex(g)}${numToHex(b)}`;
    }

    function onClickTogglePicker() {
        setShowPicker(!isShowPicker());
    }
    function onChangeColorPickerComplete(color) {
        setColor(color.rgb);
    }
    function colorSquareStyle(color) {
        const css = "background-color: " + renderRGBOnly(color);
        return css;
    }
    const validColorConstraint = "^#[0-9A-Fa-f]{8}$";
    return <Form.Group controlId={props.controlId} data-color={props.valueFunc(props.themeSignal())}>
        <Form.Label>{props.label} <span class="colour-square" style={colorSquareStyle(color())}>&nbsp;&nbsp;&nbsp;</span></Form.Label>
        <Row>
            <Col xs={12} md={3}>
                <Form.Control
                    type="text"
                    value={renderColor(color())}
                    pattern={validColorConstraint}
                    required
                />
            </Col>

        </Row>
        <Row>
            <Col xs={12} md={3}>
                <Button onClick={onClickTogglePicker}>Choose color <i class="fa-solid fa-palette"></i></Button>
            </Col>
        </Row>
        <Show when={isShowPicker()}>
            <SketchPicker color={color()} onChangeComplete={onChangeColorPickerComplete} />
        </Show>
    </Form.Group>
}